import { defineMessages } from 'react-intl';

export default defineMessages({
    mhTitle: {
        "id": "twia.quoteandbind.views.construction.MHtitle",
        "defaultMessage": "Added Living Space - Construction Details"
    },
    title: {
        "id": "twia.quoteandbind.views.construction.title",
        "defaultMessage": "Additional Construction Details"
    },
    mhTitleRoofDetails: {
        "id": "twia.quoteandbind.views.construction.mhTitleRoofDetails",
        "defaultMessage": "Added Living Space - Roof Details"
    },
    titleRoofDetails: {
        "id": "twia.quoteandbind.views.construction.titleRoofDetails",
        "defaultMessage": "Roof Details"
    },
    mhTitleRepairsAdditions: {
        "id": "twia.quoteandbind.views.construction.mhTitleRepairsAdditions",
        "defaultMessage": "Added Living Space - Repairs/Additions"
    },
    titleRepairsAdditions: {
        "id": "twia.quoteandbind.views.construction.titleRepairsAdditions",
        "defaultMessage": "Repairs/Additions"
    },
    messageLine1: {
        "id": "twia.quoteandbind.ho.wizard.construction.banner.title.lineitem.1.message",
        "defaultMessage": "Seabrook and LaPorte: 1/1/1988 - 3/1/1996",
    },
    messageLine2: {
        "id": "twia.quoteandbind.ho.wizard.construction.banner.title.lineitem.2.message",
        "defaultMessage": "Morgan's Point: 1/1/1988 - 6/1/1996"
    },
    messageLine3: {
        "id": "twia.quoteandbind.ho.wizard.construction.banner.title.lineitem.3.message",
        "defaultMessage": "Pasadena and Shoreacres: 1/1/1988 - 3/1/1997"
    },
    messageLine0: {
        "id": "twia.quoteandbind.ho.wizard.construction.banner.title.message",
        "defaultMessage": "An Official Building Statement is required for the cities and construction dates shown below:"
    },
})